module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "priceTotalHolder"
  }, [(_vm.reservation.billing) ? _c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "col-sm-12 bg-lighter py-2 border-bottom-light"
  }, [_c('div', {
    staticClass: "darkest fs-small d-flex justify-content-between"
  }, [_c('span', [_vm._v("Ticket Price")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalProductGrossprice)) + " €")])]), _vm._v(" "), _c('div', {
    staticClass: "darkest fs-small d-flex justify-content-between"
  }, [_c('span', [_vm._v("Extras")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', {
    staticClass: "w-25 text-right"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalComponentGrossprice)) + " €")])]), _vm._v(" "), (!_vm.reservation.attachPromocode && _vm.reservation.attachDiscount) ? _c('div', {
    staticClass: "darkest fs-small d-flex justify-content-between align-items-center align-items-center border-bottom-light mb-1 pb-1"
  }, [_c('span', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v("Discount\n\n                    "), (!_vm.editingDiscount) ? _c('span', {
    staticClass: "px-1"
  }, [_vm._v(_vm._s(_vm.reservation.attachDiscount.value) + _vm._s((_vm.reservation.attachDiscount.valueType == 1) ? '%' : '€'))]) : _vm._e(), _vm._v(" "), (_vm.editingDiscount) ? _c('span', {
    staticClass: "d-flex px-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.attachDiscount.value),
      expression: "reservation.attachDiscount.value"
    }],
    staticClass: "glued-right px-2 py-0 text-center border-medium",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "number",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.reservation.attachDiscount.value)
    },
    on: {
      "focus": _vm.discountInputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.attachDiscount, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.reservation.attachDiscount.valueType == 1) ? _c('div', {
    staticClass: "glued-left w-25 py-0 px-1 pointer dark border-medium",
    staticStyle: {
      "width": "auto !important"
    },
    on: {
      "click": _vm.switchDiscountType
    }
  }, [_vm._v("%")]) : _vm._e(), _vm._v(" "), (_vm.reservation.attachDiscount.valueType == 0) ? _c('div', {
    staticClass: "glued-left w-25 py-0 px-1 pointer dark border-medium",
    staticStyle: {
      "width": "auto !important"
    },
    on: {
      "click": _vm.switchDiscountType
    }
  }, [_vm._v("€")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editingDiscount) ? _c('button', {
    staticClass: "btn secondary tiny mr-1",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.applyingCustomDiscount
    }
  }, [_vm._v("Apply")]) : _vm._e(), _vm._v(" "), ((!_vm.isReservationReadOnly || _vm.reservation.status == 5) && !_vm.reservation.flags.isFullyInvoiced) ? _c('button', {
    staticClass: "btn secondary tiny ml-1",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.editingDiscountToogle
    }
  }, [_vm._v(_vm._s((_vm.editingDiscount) ? 'Remove' : 'EDIT'))]) : _vm._e()]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalDiscounts)) + " €")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "darkest fs-small d-flex justify-content-between border-bottom-light mb-1 pb-1"
  }, [_c('span', [_vm._v("Cost")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', {
    staticClass: "w-25 text-right"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.cost)) + " €")])]), _vm._v(" "), _c('div', {
    staticClass: "darkest fs-small d-flex justify-content-between"
  }, [_c('span', [_vm._v("Paid")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', {
    staticClass: "w-25 text-right"
  }, [_vm._v(_vm._s(_vm.formatPrice(this.reservationTotalPaid)) + " €")])]), _vm._v(" "), _c('div', {
    staticClass: "darkest fs-small d-flex justify-content-between border-bottom-light pb-1 mb-1"
  }, [_c('span', [_vm._v("Refunds")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('div', [(_vm.pendingRefund) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Pending'),
      expression: "'Pending'"
    }],
    staticClass: "w-25 text-right mr-2 dark"
  }, [_c('i', {
    staticClass: "fas fa-hourglass-half mr-1 dark fs-small"
  }), _vm._v("-" + _vm._s(_vm.formatPrice(_vm.pendingRefund)) + " €\n                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "w-25 text-right"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.refunds - _vm.pendingRefund)) + " €")])])]), _vm._v(" "), _c('div', {
    staticClass: "darkest fs-large d-flex justify-content-between border-bottom-light mb-1 pb-1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Total")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('div', [(_vm.pendingRefund) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('If refund is accepted'),
      expression: "'If refund is accepted'"
    }],
    staticClass: "w-25 text-right mr-2 dark"
  }, [_c('i', {
    staticClass: "fas fa-hourglass-half mr-1 dark fs-small"
  }), _vm._v(_vm._s(_vm.formatPrice(_vm.pendingRefund)) + " €\n                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "w-25 text-right bold"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.total)) + " €")])])]), _vm._v(" "), _c('div', {
    staticClass: "darkest fs-small d-flex justify-content-between align-items-center align-items-center"
  }, [_c('span', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', [_vm._v("Commission (total)")]), _vm._v(" "), (_vm.reservation.attachPromocodeType == 1 && _vm.reservation.attachDiscount) ? _c('span', {
    staticClass: "bold ml-2"
  }, [_vm._v(_vm._s(_vm.reservation.attachPromocode))]) : _vm._e(), _vm._v(" "), (_vm.reservation.attachPromocodeType == 1 && _vm.reservation.attachDiscount && !_vm.getIsLoadingCalculations) ? _c('span', {
    staticClass: "bold ml-1"
  }, [_vm._v("(" + _vm._s(_vm.getReservationCalculations.currentChannelCommission.productValue) + _vm._s((_vm.getReservationCalculations.currentChannelCommission.productValueType == 1) ? '%' : '€') + ")")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fas dark ml-2 pointer",
    class: {
      'fa-eye-slash': _vm.isCommissionsExpanded,
      'fa-eye': !_vm.isCommissionsExpanded
    },
    on: {
      "click": function($event) {
        return _vm.toggleCommissionExpand()
      }
    }
  })]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotalCommission)) + " €")])]), _vm._v(" "), _vm._l((_vm.comissionTypes), function(commissionType) {
    return (_vm.isCommissionsExpanded && commissionType.active) ? _c('div', {
      staticClass: "dark fs-small d-flex justify-content-between align-items-center align-items-center"
    }, [_c('span', {
      staticClass: "d-flex align-items-center ml-2"
    }, [_vm._v("\n                    " + _vm._s(commissionType.label + '  ') + "\n                    "), (!_vm.isEditingCommissions[commissionType.type.toLowerCase()]) ? _c('span', [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(_vm.reservation.currentChannelCommission[commissionType.type.toLowerCase() + 'Value']))]), _vm._v(" "), (!_vm.reservation.currentChannelCommission || _vm.reservation.currentChannelCommission[commissionType.type.toLowerCase() + 'ValueType'] == 1) ? _c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("%")]) : _vm._e(), _vm._v(" "), (_vm.reservation.currentChannelCommission && _vm.reservation.currentChannelCommission[commissionType.type.toLowerCase() + 'ValueType'] == 0) ? _c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("€")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isEditingCommissions[commissionType.type.toLowerCase()]) ? _c('span', {
      staticClass: "d-flex px-1 align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.reservation.currentChannelCommission[commissionType.type.toLowerCase() + 'Value']),
        expression: "reservation.currentChannelCommission[commissionType.type.toLowerCase()+'Value']",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "glued-right px-2 py-0 text-center border-medium",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "disabled": _vm.disabled,
        "type": "number",
        "placeholder": "0"
      },
      domProps: {
        "value": (_vm.reservation.currentChannelCommission[commissionType.type.toLowerCase() + 'Value'])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.reservation.currentChannelCommission, commissionType.type.toLowerCase() + 'Value', _vm._n($event.target.value))
        }, function($event) {
          return _vm.overrideCommissionChanged($event, commissionType.type)
        }],
        "focus": function($event) {
          return _vm.commissionInputFocus(commissionType.type)
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), (!_vm.reservation.currentChannelCommission || _vm.reservation.currentChannelCommission[commissionType.type.toLowerCase() + 'ValueType'] == 1) ? _c('div', {
      staticClass: "glued-left w-25 py-0 px-1 pointer dark border-medium",
      staticStyle: {
        "width": "auto !important"
      },
      on: {
        "click": function($event) {
          return _vm.switchCommissionType(commissionType.type)
        }
      }
    }, [_vm._v("%")]) : _vm._e(), _vm._v(" "), (_vm.reservation.currentChannelCommission && _vm.reservation.currentChannelCommission[commissionType.type.toLowerCase() + 'ValueType'] == 0) ? _c('div', {
      staticClass: "glued-left w-25 py-0 px-1 pointer dark border-medium",
      staticStyle: {
        "width": "auto !important"
      },
      on: {
        "click": function($event) {
          return _vm.switchCommissionType(commissionType.type)
        }
      }
    }, [_vm._v("€")]) : _vm._e(), _vm._v(" "), (_vm.reservation.currentChannelCommission['isToOverwrite' + commissionType.type]) ? _c('button', {
      staticClass: "btn secondary tiny mx-1",
      attrs: {
        "disabled": _vm.disabled
      },
      on: {
        "click": function($event) {
          return _vm.updateCommissions(commissionType)
        }
      }
    }, [_vm._v("Apply")]) : _vm._e()]) : _c('span', {
      attrs: {
        "id": "hide-use-defaut"
      }
    }, [_vm._v("\n                          "), (commissionType.editable && (!_vm.isReservationReadOnly || _vm.reservation.status == 5) && !_vm.reservation.flags.isFullyInvoiced && (!_vm.reservation.attachPromocode && (_vm.reservation.attachPromocodeType === 0 || !_vm.reservation.attachPromocodeType))) ? _c('button', {
      staticClass: "btn secondary tiny",
      attrs: {
        "disabled": _vm.disabled
      },
      on: {
        "click": function($event) {
          return _vm.editingCommissionToogle(commissionType.type)
        }
      }
    }, [_vm._v(_vm._s((_vm.isEditingCommissions[commissionType.type.toLowerCase()]) ? 'Use default' : 'EDIT'))]) : _vm._e()])]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
      attrs: {
        "size": "small",
        "opacity": "0.2"
      }
    })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations['total' + commissionType.type + 'CommissionToEntityGrossprice'])) + " €")])]) : _vm._e()
  }), _vm._v(" "), (_vm.reservation.attachPromocode && _vm.reservation.attachPromocodeType == 0 && _vm.reservation.attachDiscount) ? _c('div', {
    staticClass: "fs-small d-flex justify-content-between align-items-center align-items-center"
  }, [_c('span', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v("Promocode:\n                    "), (!_vm.getIsLoadingCalculations) ? _c('span', {
    staticClass: "bold ml-1"
  }, [_vm._v(_vm._s(_vm.reservation.attachPromocode))]) : _vm._e(), _vm._v(" "), (!_vm.getIsLoadingCalculations) ? _c('span', {
    staticClass: "px-1 bold"
  }, [_vm._v("(" + _vm._s(_vm.getReservationCalculations.attachDiscount.value) + _vm._s((_vm.getReservationCalculations.attachDiscount.valueType == 1) ? '%' : '€') + ")")]) : _vm._e()]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalDiscounts)) + " €")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 bg-darker radius-bottom-right-normal radius-bottom-left-normal areaTotal align-items-center d-flex flex-row"
  }, [(_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "big",
      "opacity": "0.2"
    }
  })], 1) : (_vm.reservation.status != '-5') ? _c('div', {
    staticClass: "lightest fs-giant font-weight-600 d-flex justify-content-between align-items-center w-100 py-1"
  }, [_c('payment-status-btn', {
    attrs: {
      "reservation": _vm.reservation
    }
  }), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "big",
      "opacity": "0.2"
    }
  })], 1) : (_vm.totalDue != 0) ? _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.reservationTotalStatus)) + "€")]) : _vm._e()], 1) : (_vm.reservation.status == '-5') ? _c('div', {
    staticClass: "lightest fs-giant font-weight-600 d-flex justify-content-between align-items-center w-100 py-1"
  }, [_c('payment-status-btn', {
    attrs: {
      "reservation": _vm.reservation
    }
  }), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "big"
    }
  })], 1) : (_vm.refundTotalMissing != 0 && _vm.refundTotalMissing !== undefined) ? _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalReceived * -1)) + "€")]) : _vm._e()], 1) : _vm._e()])]) : _c('div', {
    staticClass: "dark text-center m-3 w-100"
  }, [_c('div', {
    staticClass: "fs-large darker"
  }, [_vm._v("Unable to load information")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-789a2d46"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabReservation/PriceTotal.vue
// module id = 1720
// module chunks = 0